import { render, staticRenderFns } from "./SetupContainer.vue?vue&type=template&id=02143e6e&"
import script from "./SetupContainer.vue?vue&type=script&lang=js&"
export * from "./SetupContainer.vue?vue&type=script&lang=js&"
import style0 from "./SetupContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports